/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { State } from '../../models/state';

export interface GetState$Params {
  countryCode: string;
  stateCode: string;
}

export function getState(http: HttpClient, rootUrl: string, params: GetState$Params, context?: HttpContext): Observable<StrictHttpResponse<State>> {
  const rb = new RequestBuilder(rootUrl, getState.PATH, 'get');
  if (params) {
    rb.path('countryCode', params.countryCode, {});
    rb.path('stateCode', params.stateCode, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<State>;
    })
  );
}

getState.PATH = '/geography/countries/{countryCode}/states/{stateCode}';
